export default __webpack_public_path__ + "static/media/fork-left.786149c5.svg";